import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";

function BookDemo() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);

  const features = [
    {
      number: "01",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: "Smart Discovery",
      description:
        "Your guests don't search. Visualaey's clever AI knows which photos they're in and brings those smiles straight to their screen.",
    },
    {
      number: "02",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      ),
      title: "Instant Curation",
      description:
        "From thousands of candid clicks to a clean personal album in seconds. Every laugh, every dance step, every side hug — neatly gathered without you lifting a finger.",
    },
    {
      number: "03",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
      ),
      title: "Effortless Polish",
      description:
        "Photos look naturally beautiful. No manual edits, no extra apps. Just the good stuff, ready to share or save.",
    },
    {
      number: "04",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
      ),
      title: "Super Simple Sharing",
      description:
        "Guests get their private gallery on the spot. Whether at the wedding, the after party, or scrolling on the couch a day later — memories reach them fast.",
    },
  ];

  return (
    <>
      <Header />

      <section class="py-7 gradient-section-2">
        <div class="container">
          <div class="row">
            <div className="row text-center">
              <div className="col-md-12 px-lg-8">
                <span className="text-uppercase text-white fw-semibold ls-md"></span>
                <h2 className="h1 fw-normal ls-sm text-dark lh-1 mt-1">
                  Your Event Photos,{" "}
                  <span className="fw-bold">Found Like Magic</span>
                </h2>
                <p class="lead mb-0 lh-sm ls-sm text-dark">
                  One selfie is all it takes. Visualaey spots your face in every
                  photo from the event and hands you a private gallery, right on
                  your phone. No tagging. No hunting. Just your moments,
                  delivered.
                </p>
                <span class="text-dark d-block text-uppercase fw-semibold ls-md mt-4">
                  Why Hosts and Planners Love Visualaey
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              fontFamily: "'DM Sans', sans-serif",
              padding: "2.5rem 1.5rem  1rem",
              background: "transparent",
            }}
          >
            <style>{`
              @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&family=DM+Mono:wght@400;500&display=swap');
      
              .feat-card {
                display: flex;
                align-items: flex-start;
                gap: 16px;
                background: #F4F3EF;
                border-radius: 16px;
                padding: 20px 22px;
                transition: background 0.2s ease, transform 0.2s ease;
                cursor: default;
              }
              .feat-card:hover {
                background: #ECEAE4;
                transform: translateY(-2px);
              }
              .feat-card.active {
                background: #ECEAE4;
                transform: translateY(-2px);
              }
              .feat-num {
                flex-shrink: 0;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background: #fff;
                border: 1px solid #E2DFD8;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: 'DM Mono', monospace;
                font-size: 12px;
                font-weight: 500;
                color: #888580;
                transition: background 0.2s, color 0.2s, border-color 0.2s;
              }
              .feat-card:hover .feat-num,
              .feat-card.active .feat-num {
                background: #1A1A2E;
                color: #fff;
                border-color: #1A1A2E;
              }
              .feat-icon {
                color: #B8B4AC;
                margin-top: 1px;
                transition: color 0.2s;
                flex-shrink: 0;
              }
              .feat-card:hover .feat-icon,
              .feat-card.active .feat-icon {
                color: #4A6CF7;
              }
              .feat-title {
                margin: 0 0 5px;
                font-size: 15px;
                font-weight: 500;
                color: #1A1A2E;
                line-height: 1.2;
              }
              .feat-desc {
                margin: 0;
                font-size: 13px;
                color: #7A7670;
                line-height: 1.3;
              }
            `}</style>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
              }}
            >
              {features.map((f, i) => (
                <div
                  key={i}
                  className={`pe-4 feat-card${hovered === i ? " active" : ""}`}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <div className="feat-num">{f.number}</div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      <span className="feat-icon">{f.icon}</span>
                      <h3 className="feat-title">{f.title}</h3>
                    </div>
                    <p className="feat-desc">{f.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section class="py-8 bg-white">
        <div class="container">
          <div class="row mb-7 justify-content-center">
            <div class="col-12 text-center">
              <span class="text-primary d-block text-uppercase fw-semibold ls-xl">
                What a Demo Looks Like
              </span>
              <h2 class="mb-2 display-5 fw-semibold">
                It's relaxed, zero pressure, and honestly quite fun.
              </h2>
              <p class="lead mb-0 lh-sm ls-sm">
                In a single friendly session, we'll walk you through exactly how
                Visualaey works for your kind of event. You'll see how a selfie
                turns into a gallery, how your guests access their photos
                without downloading anything, and how much time you'll save when
                the photo sorting takes care of itself. We'll answer every
                question and even help you set up your first free event if
                you're ready.
              </p>
            </div>
          </div>

          <div className="row g-2">
            <div className="col-lg-6 col-12">
              <div className="pe-4 pe-xl-2 me-xl-5">
                <div>
                  <form className="row g-2 needs-validation" noValidate="">
                    <div className="mb-1 col-12">
                      <label className="form-label" htmlFor="fname">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control bg-white rounded-3"
                        type="text"
                        name="last name"
                        placeholder="Enter Full Name"
                        required=""
                      />
                    </div>
                    <div className="mb-1 col-12 col-md-6">
                      <label className="form-label" htmlFor="email">
                        Email ID <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control bg-white rounded-3"
                        type="email"
                        placeholder="Enter Email"
                        required=""
                      />
                    </div>
                    <div className="mb-1 col-12 col-md-6">
                      <label className="form-label" htmlFor="phone">
                        Phone No. <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control bg-white rounded-3"
                        type="text"
                        name="phone"
                        placeholder="Enter Phone"
                        required=""
                      />
                    </div>
                    <div className="mb-1 col-12">
                      <label
                        className="text-dark form-label"
                        htmlFor="contactReason"
                      >
                        Company / Organization
                      </label>
                      <input
                        className="form-control bg-white rounded-3"
                        type="text"
                        name="reason"
                        placeholder="Enter Company / Organization"
                        required=""
                      />
                    </div>
                    <div className="mb-2 col-12">
                      <label
                        className="text-dark form-label"
                        htmlFor="messages"
                      >
                        Message
                      </label>
                      <textarea
                        className="form-control bg-white rounded-3"
                        rows={3}
                        placeholder="Enter Message"
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary px-5 rounded-pill"
                      >
                        Request Demo
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <img
                src="/assets/images/3.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="400"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="pt-8 pb-5">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="row text-center d-flex justify-content-center">
                <div class="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <h2 class="fw-bold text-white mb-0">
                    Do you want more{" "}
                    <u class="text-white">
                      <span class="text-white">information?</span>
                    </u>
                  </h2>
                  <p class="lead text-white opacity-75 lh-sm mt-2">
                    Dive into our FAQs to find detailed insights, helpful tips,
                    and everything you need to know about Visualaey
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10 pb-lg-0 pb-3 d-flex align-items-center">
              <div
                class="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How does Visualaey work?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Visualaey uses facial recognition and deep learning to
                        identify individuals in event photos. Guests simply
                        upload a selfie, and our AI instantly finds and collects
                        every image they appear in—no manual tagging required.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        Is the platform secure and private?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Yes. We use industry-standard security protocols (OAuth
                        2.0 / JWT) and end-to-end encryption to protect your
                        data. Facial data is processed securely and never shared
                        or sold.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        What types of events is Visualaey best for?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Visualaey is perfect for weddings, parties, birthdays,
                        reunions, corporate events, festivals, and more—anywhere
                        multiple photos and people are involved.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How many events can I create for free?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-light opacity-75 lh-sm">
                        Your first 3 events are completely free—with full access
                        to all features. After that, you can upgrade to a
                        simple, flexible subscription plan.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6 text-center">
              <Link to="/contact" class="lead lh-1">
                More questions? Contact Us{" "}
                <i className="bi bi-arrow-right fs-4 ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default BookDemo;
